import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';

type NamespacedContent = Record<string, Record<string, unknown>>;
type SessionStorageSet = { content?: NamespacedContent };

export const ZAPP_STORAGE_UPDATED_EVENT = 'zapp:storage-updated';

/**
 * Notifies listeners that session storage was updated in the current tab.
 */
export function notifyStorageUpdated(): void {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ZAPP_STORAGE_UPDATED_EVENT));
  }
}

/**
 * sessionStorageSetHandler
 * Stores all values from options.content into sessionStorage using a namespaced key format:
 * "namespace:key" -> JSON.stringify(value)
 * required for @{ctx/namespace:key} -> retrieving value stored in sessionStorage
 */
export const sessionStorageSetHandler: ActionHandler<SessionStorageSet> = (
  action
) => {
  const { content } = (action.options ?? {}) as SessionStorageSet;
  if (!content || typeof content !== 'object') return ActionResult.Error;

  for (const [namespace, entries] of Object.entries(content)) {
    if (!entries || typeof entries !== 'object') continue;
    for (const [key, value] of Object.entries(entries)) {
      const storageKey = `${namespace}:${key}`;
      const serializedValue = JSON.stringify(value);

      sessionStorage.setItem(storageKey, serializedValue);
    }
  }

  notifyStorageUpdated();

  return ActionResult.Success;
};
